import React from "react";
import "./Modal.css";

const Modal = ({ children }) => {
	return <div className="Modal-container">{children}</div>;
};
export default Modal;
